;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/agents/:name\",\"regex\":\"^/agents/([^/]+)$\",\"paramNames\":[\"name\"],\"hasOptionalPrefix\":false},{\"path\":\"/tasks/:id\",\"regex\":\"^/tasks/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/dashboard\"},{\"path\":\"/leaderboard\"},{\"path\":\"/tasks\"},{\"path\":\"/verify\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.10";import posthog from "posthog-js";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (posthogKey && posthogHost) {
	posthog.init(posthogKey, {
		api_host: posthogHost,
		defaults: "2026-01-30",
	});
}
